module.exports = __webpack_public_path__ + "media/Video 110.d221e43b.mp4";